import { render, staticRenderFns } from "./SettingsSlack.vue?vue&type=template&id=2ea3c2ee&scoped=true&lang=pug&"
import script from "./SettingsSlack.vue?vue&type=script&lang=js&"
export * from "./SettingsSlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea3c2ee",
  null
  
)

export default component.exports